/**
 * `onPointerDownOutside` for a Radix dialog that hosts a file input (#4159).
 *
 * iOS fires a pointerdown on `<html>` as its native file picker opens. Radix reads that as
 * a tap outside and closes the dialog, which unmounts the input before the chosen file is
 * delivered: the member picks a photo and nothing happens, with no error and no event.
 * Proven on a real iPhone; desktop and emulation never see it. A real tap outside a modal
 * dialog lands on its overlay, never on `<html>` itself.
 */
export function keepOpenForFilePicker(event: CustomEvent<{ originalEvent: PointerEvent }>) {
  if (event.detail.originalEvent.target !== document.documentElement) {
    return;
  }

  event.preventDefault();
}
